export default {
  // AutonomousTeachingActivityView
  editActivity: 'Edit Autonomous Teaching Activity',
  deleteActivityConfirmation: 'Are you sure you want to delete the Autonomous Teaching Activity?',
  activityDeleted: 'Autonomous Teaching Activity deleted.',
}
